// enregistrerServiceWorker.js — branchement du service worker de public/.
//
// Le fichier lui-même (public/service-worker.js) documente ce qu'il met en
// cache et surtout ce qu'il refuse de mettre en cache. Ici, on ne s'occupe que
// de son installation.
//
// COMMENT ON LE RETIRE, SI UN JOUR IL FAUT
//
// Un service worker survit à un déploiement : il est déjà chez l'usager, et un
// nouveau build ne le désinstalle pas. Le seul moyen sûr de s'en débarrasser
// pour TOUT LE MONDE est de déployer un `public/service-worker.js` qui se
// désinscrit lui-même :
//
//     self.addEventListener('install', () => self.skipWaiting());
//     self.addEventListener('activate', (e) => e.waitUntil(
//       self.registration.unregister()
//         .then(() => caches.keys())
//         .then((n) => Promise.all(n.map((c) => caches.delete(c))))
//         .then(() => self.clients.matchAll())
//         .then((clients) => clients.forEach((c) => c.navigate(c.url)))
//     ));
//
// Ne PAS se contenter de supprimer le fichier : le service worker déjà installé
// continuerait de tourner, et l'échec du téléchargement de sa mise à jour ne le
// désinstalle pas. `desinscrire()` ci-dessous ne vaut que pour son propre
// navigateur, en débogage.

const CHEMIN = '/service-worker.js';

/**
 * @returns {Promise<ServiceWorkerRegistration|null>}
 */
export async function enregistrerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return null;

  // Depuis une iframe, l'enregistrement porterait sur la même origine mais ne
  // servirait à rien : l'installation y est impossible et le chatbot public est
  // justement diffusé de cette façon depuis les ENT. On s'abstient.
  try {
    if (window.self !== window.top) return null;
  } catch (e) {
    return null;
  }

  try {
    return await navigator.serviceWorker.register(CHEMIN, {
      scope: '/',
      // Le script du service worker ne doit jamais venir du cache HTTP :
      // c'est ce qui fige une version fautive chez l'usager.
      updateViaCache: 'none',
    });
  } catch (e) {
    // Un échec n'a aucune conséquence fonctionnelle : l'application marche
    // sans. Inutile d'alerter qui que ce soit.
    console.warn('[PWA] Service worker non enregistré :', e && e.message);
    return null;
  }
}

/** Branche l'enregistrement après le chargement, pour ne pas lui disputer la bande passante. */
export function planifierEnregistrementServiceWorker() {
  if (typeof window === 'undefined') return;
  if (document.readyState === 'complete') {
    enregistrerServiceWorker();
  } else {
    window.addEventListener('load', () => enregistrerServiceWorker(), { once: true });
  }
}

/** Débogage local : retire le service worker et vide ses caches, sur CE navigateur. */
export async function desinscrire() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  const enregistrements = await navigator.serviceWorker.getRegistrations();
  await Promise.all(enregistrements.map((e) => e.unregister()));
  if ('caches' in window) {
    const noms = await window.caches.keys();
    await Promise.all(noms.map((n) => window.caches.delete(n)));
  }
}
